import { httpClient } from './http-client'

export { baseFetcher } from './base-fetcher'
export { httpClient }

// for backward compatibility
export default httpClient
